<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="space-1">

  <div *ngIf="events.length == 0"  class="row no-gutters no-candidates">
    <div class="col-sm-12 my-auto">
      <h1><i class="fas fa-empty-set"></i></h1>
      <h4>No Favorites</h4>
      <p>You have not favorited any events yet.</p>
    </div>
  </div>

  <div *ngFor="let event of events" class="card mb-5">
    <bxl-event-item [event]="event"></bxl-event-item>
  </div>
  <p-paginator *ngIf="events && events.length > 0" [rows]="pageSize" [first]="currentPage * pageSize" [totalRecords]="resultCount" (onPageChange)="paginate($event)" [rowsPerPageOptions]="[10, 20, 30, 50]"></p-paginator>

  <div class="py-3"></div>
</div>
